<template>
  <nav class="header-menu__wrapper">
    <ul class="header-menu__container">
      <li
        v-for="link in filteredNavigationLinks"
        :key="link.title"
        class="header-menu__item"
      >
        <a-link
          :to="link.to"
          class="header-menu__item-link uppercase"
          @click="onItemClick"
        >
          {{ link.title }}
        </a-link>
      </li>
    </ul>
  </nav>
</template>

<script>
import { ELEMENT_ID, ELEMENT_SELECTOR_BY_ELEMENT_ID } from 'enums/element-id'
import { ROUTE_NAME } from 'enums/routes'
import { mapGetters, mapActions } from 'vuex'
import { VOTING_STATUS } from 'sections/_voting/VotingVoteSection/VotingVoteForm/enums'

export default {
  name: 'AHeaderNavigation',
  consts: {
    ELEMENT_ID,
    ELEMENT_SELECTOR_BY_ELEMENT_ID,
    LINKS: [
      {
        title: 'About Us',
        to: {
          name: ROUTE_NAME.HOMEPAGE,
          hash: ELEMENT_SELECTOR_BY_ELEMENT_ID[ELEMENT_ID.ABOUT_SECTION]
        },
        hideWhenVoted: true
      },
      {
        title: 'Judges',
        to: {
          name: ROUTE_NAME.HOMEPAGE,
          hash:
            ELEMENT_SELECTOR_BY_ELEMENT_ID[ELEMENT_ID.JUDGES_SECTION_HOMEPAGE]
        },
        hideWhenVoted: true
      },
      {
        title: '2025 winners',
        to: {
          name: ROUTE_NAME.WINNERS
        }
      }
    ]
  },
  computed: {
    ...mapGetters({
      categories: 'categories/categories'
    }),
    votingStatus() {
      return this.categories.VotingStatus
    },
    filteredNavigationLinks() {
      if (this.votingStatus === VOTING_STATUS.SUBMITTED) {
        return this.$options.consts.LINKS.filter(link => !link.hideWhenVoted)
      }
      return this.$options.consts.LINKS
    }
  },
  methods: {
    ...mapActions({
      requestCategories: 'categories/requestCategories'
    }),
    onItemClick() {
      this.$emit('item-click')
    }
  },
  async mounted() {
    await this.requestCategories()
  }
}
</script>

<style lang="scss" scoped>
.header-menu__wrapper {
  margin-left: auto;

  .header-menu__container {
    list-style: none;
    display: flex;
    justify-content: flex-end;
  }

  .header-menu__item {
    margin-right: 25px;

    &:last-child {
      margin-right: 0;
    }
  }

  .header-menu__item-link {
    text-decoration: none;
    padding: 15px 0;
    font-size: 16px;
    color: rgba($c--white, 0.5);
    font-weight: 500;

    &:hover {
      color: $c--white;
    }
  }
}
</style>
